import React, {memo} from 'react'
import Container from '@mui/material/Container'
import useTranslation from '../util/translations/useTranslation'
import Grid from '@mui/material/Grid'
import {
    ROUTE_CONTACT,
    ROUTE_COURSES,
    ROUTE_IMPRINT,
    ROUTE_LANG_CONTACT,
    ROUTE_LANG_COURSES,
    ROUTE_LANG_IMPRINT,
    ROUTE_LANG_PRICING,
    ROUTE_LANG_PRIVACY,
    ROUTE_LANG_STUDIO,
    ROUTE_LANG_TEAM,
    ROUTE_PRICING,
    ROUTE_PRIVACY,
    ROUTE_STUDIO,
    ROUTE_TEAM,
} from '../Routes'
import Link from 'next/link'
import Image from 'next/image'
import Typography from '@mui/material/Typography'
import IMAGE_URBANSPORTS from '../../public/images/footer/urbansports.png'
import IMAGE_HANSEFIT from '../../public/images/footer/hansefit.png'
import IMAGE_OCTIV from '../../public/images/footer/octiv.png'
import IMAGE_THERAPY from '../../public/images/footer/therapy.png'
import IMAGE_WELLHUB from '../../public/images/footer/wellhub.png'
import IMAGE_MOVEAROUND from '../../public/images/footer/movearound.jpeg'
import IMAGE_WELLPASS from '../../public/images/footer/wellpass.png'
import AppVersion from './basic/AppVersion'
import Body from './shared/Text/Body'

function Footer() {
    const {getT} = useTranslation()

    return (
        <footer>
            <div className='friendscontainer '>
                <Container>
                    <Grid container
                          direction='row'
                          alignItems='center'
                          spacing={1.5}
                          style={{
                              flexGrow: 1,
                              paddingTop: '0.5em',
                              paddingBottom: '0.5em',
                          }}>
                        <Grid className='partner-headline' size={{xs: 12}}>
                            <Typography variant='h2' className='headline'>
                                {getT('footer.partner')}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://octivfitness.com/de/'
                                title='Octiv Fitness'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='Octiv' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Octiv Logo'
                                            src={IMAGE_OCTIV}
                                            placeholder='blur'
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}} className='second_partner'>
                            <Link
                                href='https://www.hansefit.de/'
                                title='Hansefit'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='Hansefit' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Hansefit Logo'
                                            src={IMAGE_HANSEFIT}
                                            placeholder='blur'
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://urbansportsclub.com/de'
                                title='Urban Sports Club'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='Urban Sports' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Urban Sports Club Logo'
                                            src={IMAGE_URBANSPORTS}
                                            placeholder='blur'
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://therapiezentrum-langenhagen.de/'
                                title='TZ Langenhagen'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='TZ Langenhagen' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Therapy Langenhagen Logo'
                                            src={IMAGE_THERAPY}
                                            placeholder='blur'
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://wellhub.com/de-de/'
                                title='Wellhub'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='Wellhub' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Wellhub Logo'
                                            src={IMAGE_WELLHUB}
                                            placeholder='blur'
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://egym-wellpass.com/'
                                title='Wellpass eGym'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='WELLPASS' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='Wellpass eGym Logo'
                                            src={IMAGE_WELLPASS}
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                        <Grid size={{xs: 6, sm: 4, md: 2, lg: 2, xl: 2}}>
                            <Link
                                href='https://movearound.fit/'
                                title='movearound'
                                target='_blank'
                                rel='noopener noreferrer nofollow'
                                className='friendscontainer entry'>
                                <div>
                                    <div className='friendscontainer label'>
                                        <Body text='movearound' />
                                    </div>
                                    <div className='friendscontainer image'>
                                        <Image
                                            alt='movearound Logo'
                                            src={IMAGE_MOVEAROUND}
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                            }} />
                                    </div>
                                </div>
                            </Link>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='infocontainer'>
                <Container>
                    <hr className='divider mobile__hide' />
                    <Grid container
                          spacing={2}
                          direction='row'
                          justifyContent='center'
                          style={{
                              paddingTop: '0.3em',
                              paddingBottom: '0.4em',
                          }}>
                        <Grid size={{xs: 12, sm: 4, md: 4, lg: 4, xl: 4}}>
                            <Typography variant='h2' className='headline'>
                                Öffnungszeiten
                            </Typography>
                            <div className='openinghours'>
                                <div className='openinghours__day'>
                                    <div className='openinghours__day-name'>Mo. - Di.</div>
                                    <div className='openinghours__day-time'>06:30 - 09:30 & 16:00 - 20:30</div>
                                </div>
                                <div className='openinghours__day'>
                                    <div className='openinghours__day-name'>Mittwoch</div>
                                    <div className='openinghours__day-time'>06:30 - 11:30 & 16:00 - 20:30</div>
                                </div>
                                <div className='openinghours__day'>
                                    <div className='openinghours__day-name'>Donnerstag</div>
                                    <div className='openinghours__day-time'>06:30 - 09:30 & 16:00 - 20:30</div>
                                </div>
                                <div className='openinghours__day'>
                                    <div className='openinghours__day-name'>Freitag</div>
                                    <div className='openinghours__day-time'>06:30 - 10:30 & 16:00 - 19:00</div>
                                </div>
                                <div className='openinghours__day'>
                                    <div className='openinghours__day-name'>Samstag - Sonntag</div>
                                    <div className='openinghours__day-time'>10:00 - 13:00</div>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{xs: 12, sm: 4, md: 4, lg: 4, xl: 4}}>
                            <Typography variant='h2' className='headline'>
                                {getT('imprint.footer.headline')}
                            </Typography>
                            <Body text={getT('imprint.footer.company')} />
                            <Body text={getT('imprint.taxnumber')} />
                        </Grid>
                        <Grid size={{xs: 12, sm: 4, md: 4, lg: 4, xl: 4}}>
                            <Typography variant='h2' className='headline'>
                                {getT('footer.links')}
                            </Typography>
                            <ul style={{
                                listStyleType: 'none',
                                padding: 0,
                                margin: 0,
                            }}>
                                <li>
                                    <Link
                                        href={ROUTE_LANG_COURSES}
                                        as={ROUTE_COURSES}
                                        className='link-decoration__footer'>
                                        <p>{getT('links.courses.name')}</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        href={ROUTE_LANG_PRICING}
                                        as={ROUTE_PRICING}
                                        className='link-decoration__footer'>
                                        <p>{getT('links.pricing.name')}</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        href={ROUTE_LANG_TEAM}
                                        as={ROUTE_TEAM}
                                        className='link-decoration__footer'>
                                        <p>{getT('links.team.name')}</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        href={ROUTE_LANG_STUDIO}
                                        as={ROUTE_STUDIO}
                                        className='link-decoration__footer'>
                                        <p>{getT('links.studio.name')}</p>
                                    </Link>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                    <hr className='divider' />
                    <div className='footer-bottom-row'>
                        <Grid container
                              spacing={2}
                              direction='row'
                              justifyContent='flex-start'>
                            <Grid>
                                <Link
                                    href={ROUTE_LANG_IMPRINT}
                                    as={ROUTE_IMPRINT}
                                    className='link-decoration__footer'>
                                    <p>{getT('links.imprint.name')}</p>
                                </Link>
                            </Grid>
                            <Grid>
                                <Link
                                    href={ROUTE_LANG_PRIVACY}
                                    as={ROUTE_PRIVACY}
                                    className='link-decoration__footer'>
                                    <p>{getT('links.privacy.name')}</p>
                                </Link>
                            </Grid>
                            <Grid>
                                <Link
                                    href={ROUTE_LANG_CONTACT}
                                    as={ROUTE_CONTACT}
                                    className='link-decoration__footer'>
                                    <p>{getT('links.contact.name')}</p>
                                </Link>
                            </Grid>
                        </Grid>
                    </div>
                    <hr className='divider' />
                    <Grid container
                          spacing={2}
                          direction='row'
                          justifyContent='center'>
                        <Grid size={12}>
                            <AppVersion builtBy />
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </footer>
    )
}

export default memo(Footer)
